import Alert from 'react-bootstrap/Alert'

import { useCard } from '@/utils/fetcher'
import { formatUrl } from '@/utils/helpers'

const PluginError = ({ cardName }: { cardName: string }) => {
  const name = formatUrl(cardName.split('|')[0])
  const { data, error } = useCard({ card: { name }, name: cardName })

  if (error || data?.typo) {
    return (
      <>
        {data?.typo && <Alert variant='warning'>[edhrec-plugin:typo] {cardName}</Alert>}
        {error && <Alert variant='danger'>[edhrec-plugin:error] {cardName}</Alert>}
      </>
    )
  }
}

type Props = {
  cardNames: string[]
  errors: string[]
}

const Errors = ({ cardNames, errors }: Props) => (
  <div className='d-grid gap-2'>
    {errors.map((error, i) => (
      <Alert key={`plugin-error-${i}`} variant='danger'>
        {error}
      </Alert>
    ))}
    {cardNames.map((cardName, i) => (
      <PluginError cardName={cardName} key={`plugin-error-${i}`} />
    ))}
  </div>
)

export default Errors
